const menuData = [
    {
    id: 1,
    label: "Nos services",
    items: [
      {
          name: "Forums en ligne Emploi Handicap",
          routePath: "/#forum"
      },
      {
          name: "Formation et Sensibilisation Handicap",
          routePath: "/#formation"
      },
      {
          name: "Webinaires de sensibilisation",
          routePath: "/#webinaires"
      },
      {
          name: "Hotline Handicap",
          routePath: "/#hotline"
      },
    ],
  },
  {
    id: 2,
    label: "Le groupe",
    routePath: "/#video",
  },
  {
    id: 3,
    label: "Contact",
    routePath: "/#contact",
  },
];

export default menuData;
